"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _InitialPropsRunner = _interopRequireDefault(require("./runner/InitialPropsRunner"));

var _FirstComponentLoadRunner = _interopRequireDefault(require("./runner/FirstComponentLoadRunner"));

var _LoadRunner = _interopRequireDefault(require("./runner/LoadRunner"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var Router =
/*#__PURE__*/
function () {
  function Router(connector) {
    _classCallCheck(this, Router);

    this.connector = connector;
    this.initialProps = null;
    this.firstComponent = null;
  }

  _createClass(Router, [{
    key: "route",
    value: function route(path, component, name) {
      this.connector.routeMatcher.addRoute(path, component, name, false);
    }
  }, {
    key: "asyncRoute",
    value: function asyncRoute(path, component, name) {
      this.connector.routeMatcher.addRoute(path, component, name, true);
    }
  }, {
    key: "setFirstComponent",
    value: function setFirstComponent(component) {
      this.firstComponent = component;
    }
  }, {
    key: "setInitialProps",
    value: function setInitialProps(initialProps) {
      this.initialProps = initialProps;
    }
  }, {
    key: "run",
    value: function run(callback) {
      var runner = this.getRunner();
      runner.run(callback);
    }
  }, {
    key: "getRunner",
    value: function getRunner() {
      if (!!this.initialProps) {
        return new _InitialPropsRunner.default(this.connector, this.initialProps);
      }

      if (!!this.firstComponent) {
        return new _FirstComponentLoadRunner.default(this.connector, this.firstComponent);
      }

      return new _LoadRunner.default(this.connector);
    }
  }]);

  return Router;
}();

exports.default = Router;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


//////////////////
// WEBPACK FOOTER
// ./node_modules/async-react-router/lib/Router.js
// module id = 249
// module chunks = 0